import {
  INICIA_ANO_LETIVO,
  SALVA_ANO_LETIVO,
  REMOVE_ANO_LETIVO,
  NOVO_ANO_LETIVO,
  BUSCA_ANO_LETIVO_EDICAO,
  INICIO_ANO_LETIVO_SUCESSO,
  SALVA_ANO_LETIVO_SUCESSO,
  REMOVE_ANO_LETIVO_SUCESSO,
  BUSCA_ANO_LETIVO_EDICAO_SUCESSO,
  ATUALIZA_ANO_LETIVO,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_ANO_LETIVO,
  LISTA_ANO_LETIVO_SUCESSO,
  LIMPAR_ANO_LETIVO,
  LISTA_TIPOS_ETAPAS_ANO_LETIVO,
  LISTA_TIPOS_ETAPAS_ANO_LETIVO_SUCESSO,
  APLICA_FILTRO_ANO_LETIVO
} from 'constants/ActionTypes';
import { LISTA_ESCOLAS_ANO_LETIVO, LISTA_ESCOLAS_ANO_LETIVO_SUCESSO } from 'constants/ActionTypes';
import {
  ANOLETIVO_TIPOETAPA_MODAL_OPEN,
  ANOLETIVO_TIPOETAPA_MODAL_CLOSE,
  ANOLETIVO_TIPOETAPA_MODAL_ATUALIZA_CAMPO,
  ANOLETIVO_TIPOETAPA_SALVAR,
  ANOLETIVO_TIPOETAPA_ATUALIZAR,
  ANOLETIVO_TIPOETAPA_SALVAR_SUCESSO,
  ANOLETIVO_TIPOETAPA_ATUALIZAR_SUCESSO
} from 'constants/ActionTypes';

export const iniciaAnoLetivo = () => ({ type: INICIA_ANO_LETIVO });

export const salvaAnoLetivo = (anoLetivo) => ({ type: SALVA_ANO_LETIVO, payload: anoLetivo });

export const atualizaAnoLetivo = (anoLetivo) => ({ type: ATUALIZA_ANO_LETIVO, payload: anoLetivo });

export const removeAnoLetivo = (id) => ({ type: REMOVE_ANO_LETIVO, payload: id });

export const listaAnoLetivo = (filtros) => ({ type: LISTA_ANO_LETIVO, payload: filtros || {} });

export const novoAnoLetivo = () => ({ type: NOVO_ANO_LETIVO });

export const buscaAnoLetivoEdicao = (id) => ({ type: BUSCA_ANO_LETIVO_EDICAO, payload: id });

export const inicioAnoLetivoSucesso = (payload) => ({ type: INICIO_ANO_LETIVO_SUCESSO, payload });

export const salvaAnoLetivoSucesso = (mensagem) => ({ type: SALVA_ANO_LETIVO_SUCESSO, payload: mensagem });

export const removeAnoLetivoSucesso = (mensagem) => ({ type: REMOVE_ANO_LETIVO_SUCESSO, payload: mensagem });

export const buscaAnoLetivoEdicaoSucesso = (payload) => ({ type: BUSCA_ANO_LETIVO_EDICAO_SUCESSO, payload });

export const listaAnoLetivoSucesso = (payload) => ({ type: LISTA_ANO_LETIVO_SUCESSO, payload });

export const limparFiltroAnoLetivo = () => ({ type: LIMPAR_ANO_LETIVO });

export const showAuthLoader = () => ({ type: ON_SHOW_LOADER });

export const hideMessage = () => ({ type: HIDE_MESSAGE });

export const showAuthMessage = (message) => ({ type: SHOW_MESSAGE, payload: message });

export const showSuccessMessage = (message) => ({ type: ON_SHOW_SUCCESS_MESSAGE, payload: message });

export const listaTiposEtapasAnoLetivo = (escolaId) => ({ type: LISTA_TIPOS_ETAPAS_ANO_LETIVO, payload: { escolaId } });

export const listaTiposEtapasAnoLetivoSucesso = (tipos) => ({ type: LISTA_TIPOS_ETAPAS_ANO_LETIVO_SUCESSO, payload: { tipos } });

// Modal de microgerência Tipo de Etapa
export const openTipoEtapaModal = (dadosInicial) => ({ type: ANOLETIVO_TIPOETAPA_MODAL_OPEN, payload: dadosInicial || null });
export const closeTipoEtapaModal = () => ({ type: ANOLETIVO_TIPOETAPA_MODAL_CLOSE });
export const atualizaCampoTipoEtapaModal = (nome, valor) => ({ type: ANOLETIVO_TIPOETAPA_MODAL_ATUALIZA_CAMPO, payload: { nome, valor } });
export const salvarTipoEtapa = (dados) => ({ type: ANOLETIVO_TIPOETAPA_SALVAR, payload: dados });
export const atualizarTipoEtapa = (id, dados) => ({ type: ANOLETIVO_TIPOETAPA_ATUALIZAR, payload: { id, dados } });
export const salvarTipoEtapaSucesso = (mensagem) => ({ type: ANOLETIVO_TIPOETAPA_SALVAR_SUCESSO, payload: mensagem });
export const atualizarTipoEtapaSucesso = (mensagem) => ({ type: ANOLETIVO_TIPOETAPA_ATUALIZAR_SUCESSO, payload: mensagem });

export const listaEscolasAnoLetivo = () => ({ type: LISTA_ESCOLAS_ANO_LETIVO });

export const listaEscolasAnoLetivoSucesso = (escolas) => ({ type: LISTA_ESCOLAS_ANO_LETIVO_SUCESSO, payload: { escolas } });

export const onChangeFilterAnoLetivo = (e) => {
  const value = e.target ? e.target.value : e;
  return { type: APLICA_FILTRO_ANO_LETIVO, payload: value };
};
